import React, { useState, useId } from 'react'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { Collapsible, Text, Link } from '@lounge-fe/ui-kit'
import { useTranslation } from 'react-i18next'

interface ExpandingTextData {
  title?: string
  tag?: string
  text_size?: string
  description: string
  read_more_description?: string
}

export const ExpandingText: ShopifySectionComponent<ExpandingTextData> = ({
  data,
}) => {
  const { title, tag, text_size, description, read_more_description } = data!
  const [isExpanded, setIsExpanded] = useState(false)
  const { t } = useTranslation()
  const collapsibleId = useId()

  const hasReadMore = read_more_description && read_more_description.trim()

  return (
    <div>
      {title && tag && (
        <div className={text_size ? undefined : 'mb-4'}>
          {React.createElement(tag, {
            className: text_size,
            dangerouslySetInnerHTML: { __html: title },
          })}
        </div>
      )}
      {description && (
        <div className={title && tag ? 'mt-4' : undefined}>
          {hasReadMore ? (
            <>
              <Text
                variant="body-sm"
                className="text-subtle"
                dangerouslySetInnerHTML={{ __html: description }}
              />
              <Collapsible
                id={collapsibleId}
                open={isExpanded}
                transition={{ duration: '0.25s' }}
                keepMounted={true}
              >
                <Text
                  variant="body-sm"
                  className="text-subtle mt-4"
                  dangerouslySetInnerHTML={{ __html: read_more_description }}
                />
              </Collapsible>
              <Link
                as="button"
                onClick={() => setIsExpanded(!isExpanded)}
                className="link mt-3"
                aria-expanded={isExpanded}
                aria-controls={collapsibleId}
              >
                {isExpanded ? t('action.read_less') : t('action.read_more')}
              </Link>
            </>
          ) : (
            <Text
              variant="body-sm"
              dangerouslySetInnerHTML={{ __html: description }}
              className={title && tag ? 'mt-4' : undefined}
            />
          )}
        </div>
      )}
    </div>
  )
}
